<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>设备型号</el-breadcrumb-item>
          <el-breadcrumb-item>编辑型号</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="型号信息" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item prop="modelName" label="型号名称">
                  <el-input
                    v-model="model.modelName"
                    placeholder="唯一名称，不可重复"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="remark" label="备注">
                  <el-input v-model="model.remark" placeholder=""></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm('editForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      siteList: [], //站点列表
      model: {
        createdBy: "",
        factoryName: "",
        gmtCreate: "",
        gmtModified: "",
        id: 0,
        isDelete: true,
        modelName: "",
        modifiedBy: "",
        remark: "",
      },
      rules: {
        modelName: [{ required: true, message: "必填项", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      if (id) {
        AxiosAjax({
          url: "/cabinet/model/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
          },
        });
      }
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });

      Promise.all([f1]).then(() => {
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > "0") {
          AxiosAjax({
            method: "put",
            url: "/cabinet/model/update",
            data: _this.model,
            loading: true,
            successMsg: "修改型号成功",
            success: function (res) {
              //可跳转加列表页
              _this.$router.push({ name: "CabinetModelList" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            url: "/cabinet/model/save",
            data: _this.model,
            loading: true,
            successMsg: "新增型号成功",
            success: function (res) {
              //重置表单
              //_this.$refs['editForm1'].resetFields();
              //可跳转加列表页
              _this.$router.push({ name: "CabinetModelList" });
            },
          });
        }
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CabinetModel/CabinetModelEdit.vue